import React, { useEffect, useState, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import isEmpty from 'lodash/isEmpty';

import { Button, Icon, Form } from '@whalecloud/fdx';

import { SelectOfferObj } from '@/utils';
import PlanFormItems from './PlanFormItems';
import { getBaseNameKey } from './utils';

import styles from './index.module.less';

const ComboUnitOffer = props => {
  const {
    modelKey, offerDetail = {}, form, addressId, exchangeId, stdCode,
    refInstance, saveSameNumberInfo, qrySalesRuleParams, mainOfferCurrentDpp,
  } = props;

  const [planFormObj, setPlanFormObj] = useState({});

  useImperativeHandle(refInstance, () => ({
    getComboUnitInfo: async () => {
      const { validateFields } = form;
      let comboUnitList = {};
      await validateFields().then(async formDetail => {
        const { comboUnitDtoList = [] } = offerDetail;
        const list = comboUnitDtoList.map(plan => {
          const { unitId, servType } = plan;
          const basePlanList = planFormObj[unitId];
          const result = (basePlanList || []).map((it, index) => {
            const baseNameKey = getBaseNameKey(unitId, index, servType);
            // 找到所有当前输入框的form选择的数据
            const planDetail = {};
            Object.keys(formDetail).forEach(key => {
              const hasSameKey = key.includes(baseNameKey);
              if (hasSameKey) {
                const name = key.replace(baseNameKey, '');
                planDetail[name] = formDetail[key];
              }
            });
            return planDetail;
          });
          return {
            ...plan,
            planList: result,
          };
        });
        comboUnitList = list;
      });
      return comboUnitList;
    },
  }));

  const handleCurOfferNumChange = (unitId, formDataIndex, isDelete) => {
    let newFormDataGroup = planFormObj[unitId] || [];
    if (!isDelete) {
      newFormDataGroup = [...newFormDataGroup, SelectOfferObj];
    } else {
      newFormDataGroup.splice(formDataIndex, 1);
    }
    const changeObj = { [unitId]: newFormDataGroup };
    setPlanFormObj({
      ...planFormObj,
      ...changeObj,
    });
  };

  const handleNbrChange = nbrInfo => saveSameNumberInfo({ sameNumberInfo: nbrInfo });

  useEffect(() => { // 根据上级选择的 offer 信息，查询 offer 详情，组装 subsPlanGroup
    if (!isEmpty(offerDetail)) {
      const { comboUnitDtoList = [] } = offerDetail;
      const defaultPlanFormObj = {};
      // if (comboUnitList) { // 如果model中的 comboUnitList 有值的话
      //   comboUnitList.forEach(it => {
      //     defaultPlanFormObj[it.unitId] = it.planList;
      //   });
      // } else {
      //   comboUnitDtoList.forEach(it => { // 没有值，初次进入该页面
      //     const { unitId, lowerLimit } = it;
      //     const basePlanList = [];
      //     for (let i = 0; i < lowerLimit; i += 1) {
      //       basePlanList.push(SelectOfferObj);
      //     }
      //     defaultPlanFormObj[unitId] = basePlanList;
      //   });
      // }
      comboUnitDtoList.forEach(it => { // 初次进入该页面
        const { unitId, lowerLimit } = it;
        const basePlanList = [];
        for (let i = 0; i < lowerLimit; i += 1) {
          basePlanList.push(SelectOfferObj);
        }
        defaultPlanFormObj[unitId] = basePlanList;
      });
      setPlanFormObj(defaultPlanFormObj);
    }
  }, [offerDetail]);

  const renderUnitBlock = unitInfo => {
    const { unitName, unitId, lowerLimit, upperLimit } = unitInfo;
    return (
      <div className={`blockWrap ${styles.comboGroup}`} key={unitId}>
        <div className={styles.unitHeader} style={{ paddingBottom: 0 }}>
          <h3 className="blockTitle">{`${unitName}(${lowerLimit}-${upperLimit})`}</h3>
          {
            ((planFormObj[unitId] || []).length < upperLimit) && (
              <Button type="primary" onClick={() => handleCurOfferNumChange(unitId)}>
                <Icon type="plus" />
                {i18n('COMMON_NEW')}
              </Button>
            )
          }
        </div>
        {
          (planFormObj[unitId] || []).map((it, index) => (
            <PlanFormItems
              key={index}
              index={index}
              modelKey={modelKey}
              form={form}
              addressId={addressId}
              qrySalesRuleParams={qrySalesRuleParams}
              exchangeId={exchangeId}
              stdCode={stdCode}
              unitInfo={unitInfo}
              formItemData={it}
              mainOfferCurrentDpp={mainOfferCurrentDpp}
              onNbrChange={handleNbrChange}
              onDelete={() => handleCurOfferNumChange(unitId, index, true)}
            />
          ))
        }
      </div>
    );
  };

  return (
    // <Form layout="inline"></Form>
    <Form layout="inline" className={styles.comboUnitBox}>
      {
       (offerDetail.comboUnitDtoList || []).map(unitInfo => renderUnitBlock(unitInfo))
      }
    </Form>
  );
};

const mapDispatchToProps = (dispatch, { modelKey }) => ({
  saveSameNumberInfo: payload => dispatch({
    type: `${modelKey}/save`,
    payload,
  }),
});

const Component = connect((state, { modelKey }) => ({
  comboUnitList: state[modelKey].comboUnitList,
}), mapDispatchToProps)(Form.create()(ComboUnitOffer));
export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
